import { typoM } from 'pages/selections/styles';

export const radioStyles = {
  radio: {
    flexDirection: 'row',
    '& .MuiButtonBase-root:hover': {
      backgroundColor: '#fff',
    },
  },
  label: {
    marginRight: '32px',
    ...typoM,
    fontWeight: '600 !important',
    '& .MuiSvgIcon-root': {
      color: '#4D6EF5',
    },
  },
  formLabel: {
    ...typoM,
    color: '#23252F',
    textTransform: 'capitalize',
  },

  itemLabel: { ...typoM, color: '#23252F', paddingLeft: '31px' },
};
